module.exports = __webpack_public_path__ + "static/media/Logo__DSC.96f39e34.svg";